import { createTheme } from '@mui/material/styles';
import { grey,blue } from '@mui/material/colors';

const theme = createTheme({
  palette: {
    primary: {
      main: "#f82400",
    },
    secondary: {
      main: grey[500],
    },
    white: {
      main: "#ffffff",
    },
    blue: {
      main: blue[100],
    },
  },
  typography: {
    fontFamily: [
      "aktiv-grotesk",
      "Aktiv Grotesk",
      "Helvetica Neue",
      "Helvetica",
    ],
  },
});

export default theme;
